import BaseInput from 'Components/Form/BaseInput';

export interface IInformationProps {
  label: () => JSX.Element;
  type: 'information';
  name: '';
}

export default function Information(rest: IInformationProps) {
  return <BaseInput {...rest}>{() => <></>}</BaseInput>;
}
